<template>
  <div>
    <v-row  style="padding-top: 8px">
      <v-col cols="12">
        <v-text-field
          label="X meters relative to outer crest"
          :class="[getDirtyClass(itemProfile, 'x'), 'pa-0 mt-0', readonly ? 'disable-events' : '', 'text-field']"
          hide-details
          color="primary"
          type="number"
          @update:model-value="
            setXParameter(index, $event, itemProfile);
            addDirty(itemProfile, 'x');
          "
          variant="underlined"
          :model-value="itemProfile ? itemProfile.x : 0"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          :label="startSectionLabel"
          :disabled="isLeft"
          :class="[readonly ? 'disable-events' : '', 'text-field']"
          :rules="startRule(itemProfile.x_start, itemProfile.x)"
          variant="underlined"

          color="primary"
          type="number"
          @update:model-value="
            setStartParameter(index, $event, itemProfile);
            addDirty(itemProfile, 'x_start');
          "
          :model-value="startValue"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          :label="endSectionLabel"
          :disabled="isRight"
          :class="[readonly ? 'disable-events' : '', 'text-field']"
          :rules="endRule(itemProfile.x_end, itemProfile.x)"
          variant="underlined"

          color="primary"
          type="number"
          @update:model-value="
            setEndParameter(index, $event, itemProfile);
            addDirty(itemProfile, 'x_end');
          "
          :model-value="endValue"
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import DirtyFieldsMixIn from '@/mixins/DirtyFieldsMixIn.vue';
import SoilProfileMixin from '@/mixins/SoilProfileMixin.vue';
import { mapGetters } from "vuex";

export default {
  name: "SoilProfileBlockParameter",
  mixins: [DirtyFieldsMixIn, SoilProfileMixin],
  props: {
    index: {},
    itemProfile: {},
    readonly: {type: Boolean, default: false},
  },
  computed: {
    ...mapGetters("soilProfile", {
      soilProfileBlock: "getSortedSoilProfile",
    }),
    isLeft() {
      return this.index === 0;
    },
    isRight() {
      return this.index === this.soilProfileBlock.length - 1;
    },
    startSectionLabel() {
      return this.isLeft ? "Start section: Left" : "Start section [m]";
    },
    endSectionLabel() {
      return this.isRight ? "End section: Right" : "End section [m]";
    },
    startValue() {
      return this.isLeft ? null : (this.itemProfile ? this.itemProfile.x_start : 0);
    },
    endValue() {
      return this.isRight ? null : (this.itemProfile ? this.itemProfile.x_end : 0);
    },
  },
  methods: {
    startRule(xStart, x) {
      let rules = [];
      if (xStart > x) {
        rules.push("Start section value should be lower than X value");
      }
      return rules;
    },
    endRule(xEnd, x) {
      let rules = [];
      if (xEnd < x) {
        rules.push("End section value should be higher than X value");
      }
      return rules;
    },
    emptyDirtyItemsClass() {
      this.dirtyItems = [];
    },
  },
};
</script>
